import React from 'react';
import ReactDOM from 'react-dom';
import 'src/index.css';
import App from 'src/App';
import { installCsrfInterceptors } from 'src/utils/csrfToken';

// Register CSRF token capture/attach interceptors before any request is made.
installCsrfInterceptors();

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
);
